import React from "react";
import logo from "../../../assets/icons/Logo.svg";
import { Menu, Dropdown, Avatar } from "antd";
import { DownOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { resetStore } from "@stores/root-store";
import { constRoute } from "@utils/route";
import logoutIcon from "../../../assets/icons/cn-logout.svg";
import { IconButton } from "@mui/material";

function MasterAdminHeader() {
  const navigate = useNavigate();
  const currentUser = localStorage.getItem("master_userData");

  const userData = currentUser ? JSON.parse(currentUser) : null;
  const fullName = userData?.name || "User";

  // Function to generate initials
  const getInitials = (name: string) => {
    const nameParts = name.trim().split(" ");
    if (nameParts.length === 1) {
      return nameParts[0].charAt(0).toUpperCase();
    }
    return nameParts.map((part) => part.charAt(0).toUpperCase()).join("");
  };

  const initials = getInitials(fullName);

  const handleLogout = () => {
    navigate(constRoute.masteradminLogin);
    resetStore();
    localStorage.removeItem("master_token");
    localStorage.removeItem("master_email");
    localStorage.removeItem("superadmin");
    localStorage.removeItem("master_userData");
  };

  const userMenu = (
    <Menu
      style={{
        padding: 0,
        borderRadius: 8,
        overflow: "hidden",
        border: "1px solid #e5e7eb",
        minWidth: "200px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {/* Profile display row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "12px 16px",
        }}
      >
        <Avatar
          style={{
            backgroundColor: "#00B840",
            color: "#fff",
            height: 40,
            width: 40,
          }}
        >
          {initials || ""}
        </Avatar>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontWeight: 500, fontSize: 14 }}>
            {fullName || "User"}
          </span>
          <span style={{ fontSize: 12, color: "#888" }}>
            {userData?.email || ""}
          </span>
        </div>
      </div>

      {/* Divider */}
      <div style={{ borderTop: "1px solid #f0f0f0" }} />

      {/* Logout option */}
      <Menu.Item
        key="logout"
        onClick={handleLogout}
        style={{ padding: "10px 16px" }}
      >
        <IconButton size="small" onClick={handleLogout}>
          <img src={logoutIcon} alt="logout" />
        </IconButton>
        Log Out
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      style={{
        backgroundColor: "#FFF",
        position: "relative",
        borderBottom: "1px solid #E6E6E6",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 20px",
        height: "80px",
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <img
          src={logo}
          alt="Logo"
          style={{
            height: "32px",
            display: "block",
          }}
        />
      </div>

      {/* User menu */}
      {userData && (
        <div style={{ position: "relative" }}>
          <Dropdown
            overlay={userMenu}
            trigger={["click"]}
            overlayStyle={{
              position: "absolute",
              top: "calc(100% + 12px)",
              right: 0,
              zIndex: 1050,
              minWidth: "220px",
            }}
            getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
            align={{ offset: [0, 0] }}
          >
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
                height: "100%",
                padding: "0 10px",
                whiteSpace: "nowrap",
              }}
            >
              Hi,
              <span>{fullName.split(" ")[0]}</span>
              <DownOutlined />
            </div>
          </Dropdown>
        </div>
      )}
    </div>
  );
}

export default MasterAdminHeader;
